import React from 'react';
import { getAdditionalFiltersButtonText } from '../../utils/formOptions';
import {
  buildFeatureOptions,
  buildBuyingSchemeOptions,
} from '../../utils/additionalFiltersUtils';

function AdditionalFiltersDropdown({
  filterData,
  selectedFeatures,
  selectedBuyingSchemes,
  onFeatureChange,
  onBuyingSchemeChange,
  isOpen,
  onToggle,
  disabled = false,
}) {
  const featureOptions = buildFeatureOptions(filterData);
  const buyingSchemeOptions = buildBuyingSchemeOptions(filterData);

  const getButtonText = () =>
    getAdditionalFiltersButtonText(selectedFeatures, selectedBuyingSchemes);

  return (
    <fieldset className="md:border-l-2 bg-white h-15 border-[#ebebeb] md:h-full md:bg-none flex items-center justify-center relative">
      <legend className="sr-only">Filters</legend>
      <button
        type="button"
        className="text-sm font-medium flex items-center gap-3 lg:h-15"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        {getButtonText()}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          aria-hidden="true"
          focusable="false"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        >
          <use href="#icon-chevron-down" />
        </svg>
      </button>
      {isOpen && (
        <div className="z-50 absolute w-full bg-white top-full -right-[2px] p-4 border-2 border-[#ebebeb] xl:min-w-52">
          <div className="mb-4">
            <h4 className="font-light text-xs mb-3">Features</h4>
            <div className="space-y-3">
              {featureOptions.map((feature) => (
                <label key={feature.value} className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={selectedFeatures.includes(feature.value)}
                    onChange={
                      disabled
                        ? undefined
                        : () => onFeatureChange(feature.value)
                    }
                    className="w-4 h-4"
                    disabled={disabled}
                  />
                  <span
                    className={`text-sm font-light ${
                      disabled ? 'opacity-50' : ''
                    }`}
                  >
                    {feature.label}
                  </span>
                </label>
              ))}
            </div>
          </div>
          {buyingSchemeOptions.length > 0 && (
            <div className="border-t-2 pt-4 border-[#EBEBEB]">
              <h4 className="font-light text-xs mb-3">Buying Schemes</h4>
              <div className="space-y-3">
                {buyingSchemeOptions.map((scheme) => (
                  <label key={scheme.value} className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={selectedBuyingSchemes.includes(scheme.value)}
                      onChange={
                        disabled
                          ? undefined
                          : () => onBuyingSchemeChange(scheme.value)
                      }
                      className="w-4 h-4"
                      disabled={disabled}
                    />
                    <span
                      className={`text-sm font-light ${
                        disabled ? 'opacity-50' : ''
                      }`}
                    >
                      {scheme.label}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </fieldset>
  );
}

export default AdditionalFiltersDropdown;
